import { QuillProvider } from "@quillsql/react"
import Cookies from "js-cookie"

import useUser from "@hooks/useUser"

import replaceSlugs from "@utils/replaceSlugs"

import { REPORTS_ENDPOINTS } from "@endpoints/reports"

import DashboardContent from "./DashboardContent/DashboardContent"
import { useQuillTheme } from "./ReportDashboard.themes"
import { ReportDashboardProps } from "./ReportDashboard.types"

function ReportsProvider(props: { children: React.ReactNode }) {
    const { children } = props

    const { user } = useUser()
    const quillTheme = useQuillTheme()

    if (window.USE_QUILL_CLOUD) {
        return (
            <QuillProvider
                publicKey={window.QUILL_PUBLIC_KEY}
                theme={quillTheme}
                tenants={[{ tenantField: "service_company_id", tenantIds: [user?.service_company.id ?? ""] }]}
            >
                {children}
            </QuillProvider>
        )
    } else {
        const serviceCompanySlug = user?.service_company?.slug ?? "undefined"
        const queryEndpoint = replaceSlugs(REPORTS_ENDPOINTS.DATA, {
            service_company_slug: serviceCompanySlug,
        })

        return (
            <QuillProvider
                publicKey={window.QUILL_PUBLIC_KEY}
                queryEndpoint={queryEndpoint}
                queryHeaders={{
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-CSRFToken": Cookies.get("csrftoken") ?? "",
                }}
                withCredentials={true}
                theme={quillTheme}
            >
                {children}
            </QuillProvider>
        )
    }
}

export default function ReportDashboard(props: ReportDashboardProps) {
    const { dashboardId, isAddReportDialogOpen, onAddReportDialogChange } = props

    return (
        <ReportsProvider>
            <DashboardContent
                dashboardId={dashboardId}
                useCache={window.USE_QUILL_CLOUD}
                isAddReportDialogOpen={isAddReportDialogOpen}
                onAddReportDialogChange={onAddReportDialogChange}
            />
        </ReportsProvider>
    )
}
